import React from "react";
import TimerPage from "../../components/TimerPage";

const Stage3: React.FC = () => (
  <TimerPage title="3.自由辩论" initialTime={300} />
);

export default Stage3;
